module.exports = __webpack_public_path__ + "img/c2.d082ba3a.png";